<template>
  <vue-scroll v-loading.fullscreen.lock="loading">
    <div v-if="this.currentCompany === 'TB'">
      <el-row>
        <el-alert
          title="Reporte que muestra los GPS que poseen los Clientes"
          type="info"
          show-icon
          effect="dark"
        >
        </el-alert>
      </el-row>

      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total Clientes"
            icon="el-icon-user-solid info-text"
            :total="TotalClientes"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total GPS"
            icon="mdi mdi-satellite-uplink primary-text"
            :total="TotalGPS"
            :percent="PorcentajeTotal"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total GPS Activos"
            icon="mdi mdi-satellite-uplink success-text"
            :percent="PorcentajeActivo"
            :total="TotalGPSActivos"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total GPS Estacionados"
            icon="mdi mdi-satellite-uplink warning-text"
            :percent="PorcentajeEstacionados"
            :total="TotalGPSEstacionados"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total GPS Fuera de Linea"
            icon="mdi mdi-satellite-uplink danger-text"
            :percent="PorcentajeInactivos"
            :total="TotalGPSInactivos"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total GPS sin señal satelital"
            icon="mdi mdi-satellite-uplink info-text"
            :percent="PorcentajeSenalPerd"
            :total="TotalGPSsenalPerd"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>

      <el-row :gutter="60" type="flex" class="row-bg rowx" justify="end">
        <el-col>
          <el-row :gutter="1" type="flex" class="row-bg" justify="end">
            <label class="label" for="cantidad"> Tiempo sin Conexion: </label>
            <el-col :span="3">
              <el-input-number
                size="mini"
                id="cantidad"
                label="Tiempo sin Conexion: "
                v-model="num"
                controls-position="right"
                @change="handleChange"
                :min="1"
                :max="1000"
              ></el-input-number>
            </el-col>

            <el-col :span="2">
              <el-select
                size="mini"
                v-model="DiasHoras"
                align="center"
                @change="HorasFilter"
                @clear="syncAllReport()"
                clearable
                placeholder="Dias o Horas"
              >
                <el-option
                  v-for="item in optionsDiasHoras"
                  :key="item.value3"
                  :label="item.label3"
                  :value="item.value3"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>

        <rabbey-toolbox
          class="mt-0 toolbox"
          :filterables="true"
          @filter-search="onFilterSearch"
        >
          <div class="mr-5">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              size="mini"
              :loading.sync="loading"
              @click="syncAllReportButton"
              >Actualizar</el-button
            >
          </div>
        </rabbey-toolbox>

        <!--
      <el-col :span="5">
        <el-input
          placeholder="Nombre del Cliente"
          v-model="filtroNombre"
          clearable
        >
          <el-button
            icon="el-icon-search"
            slot="append"
            @click="ClientFilter"
          ></el-button>
        </el-input> 
        
      </el-col>
      -->
      </el-row>

      <el-row>
        <rabbey-table-3
          ref="table"
          class="table"
          :show-summary="true"
          sum-text="Totales de GPS"
          :loading.sync="loading"
          :columns="columnas"
          :data.sync="Resultado"
          :page-sizes="[10, 30, 50, 100, 500, 1000]"
        />

        <report-gps-detail ref="detail" />
      </el-row>
    </div>
    <!-- <div v-if="this.currentCompany === 'TB'">
      <el-row>
        <el-alert
          title="Reporte que muestra las terminales por clientes"
          type="info"
          show-icon
          effect="dark"
        >
        </el-alert>
      </el-row>
      <el-row>
        <TerminalsReport />
      </el-row>
    </div> -->
  </vue-scroll>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RabbeyToolbox from "@/components/RabbeyToolbox.vue";
import { COMPANYS } from "@/const";
import ReportGpsDetail from "@/components/reports/ReportGpsDetail.vue";
import ReportGPSHyperLink from "@/components/functionals/ReportGPSHyperLink.vue";
//import TerminalsReport from "@/components/reports/ReportTerminals";
import CardTotal from "@/components/CardTotalOriginal.vue";

export default {
  name: "DevicesReport",
  props: {
    /*
   clientNameProp: String,
    DeviceTypeProp: String
    */
  },
  TableData: [],
  //  ClientCode: [],
  //     Resultado: [],
  //     Data: [],
  //     GpsReportViewData: [],
  //     CustomerServicesData: [],

  data() {
    return {
      companys: COMPANYS,
      ClientCode: [],
      Resultado: [],
      Data: [],
      GpsReportViewData: [],
      CustomerServicesData: [],
      TotalClientes: Number,
      clientNameProp: "",
      DeviceTypeProp: "",
      //DiasHoras1: "",
      //DiasHoras2: "",
      num: 24,
      DiasHoras: "Horas",
      filtroNombre: "",
      loading: false,
      columnas: [
        {
          prop: "ClientCode",
          label: "Codigo del Cliente",
          fixed: true,
          sortable: true,
          width: "170"
        },
        {
          prop: "name",
          label: "Nombre del Cliente",
          sortable: true,
          width: "300"
        },
        {
          prop: "CustomerService",
          label: "Servicio al Cliente",
          sortable: true
        },
        {
          prop: "total_gps",
          label: "Total de GPS",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        {
          prop: "active",
          label: "GPS Activos",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        {
          prop: "idle",
          label: "GPS Estacionados",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },
          formatter: ReportGPSHyperLink
        },
        {
          prop: "offline",
          label: "GPS fuera de Linea",
          sortable: true,
          align: "center",
          cellAtrrs: {
            openDetail: this.openDetail
          },

          formatter: ReportGPSHyperLink /*(row, col) => {
            //const { Quantity } = row;

          return <a onclick="openDetail(15223, 555)" class="bold, red">{row.offline} </a>;
          },*/
        },
        {
          prop: "signal_lost",
          label: "GPS sin señal satelital",
          sortable: true,
          align: "center",
          width: "200",
          cellAtrrs: {
            openDetail: this.openDetail
          },

          formatter: ReportGPSHyperLink /*(row, col) => {
            //const { Quantity } = row;

          return <a onclick="openDetail(15223, 555)" class="bold, red">{row.offline} </a>;
          },*/
        }
      ],

      optionsDiasHoras: [
        {
          value3: "Horas",
          label3: "Horas"
        },
        {
          value3: "Dias",
          label3: "Dias"
        }
      ]
    };
  },
  computed: {
    ...mapState("navixy", [
      "list",
      "tota;_gps",
      "sum_status_by_user",
      "total_users"
    ]),
    ...mapGetters("navixy", ["getReportGpsByCurrentUser"]),
    TotalGPS() {
      return this.GpsReportViewData.map((item) => item.total_gps).reduce(
        (a, b) => a + b
      );
    },
    TotalGPSActivos() {
      return this.GpsReportViewData.map((item) => item.active).reduce(
        (a, b) => a + b
      );
    },
    TotalGPSInactivos() {
      return this.GpsReportViewData.map((item) => item.offline).reduce(
        (a, b) => a + b
      );
    },
    TotalGPSEstacionados() {
      return this.GpsReportViewData.map((item) => item.idle).reduce(
        (a, b) => a + b
      );
    },
    TotalGPSsenalPerd() {
      return this.GpsReportViewData.map((item) => item.signal_lost).reduce(
        (a, b) => a + b
      );
    },
    PorcentajeTotal() {
      return Math.round((this.TotalGPS / this.TotalGPS) * 100);
    },
    PorcentajeActivo() {
      return Math.round((this.TotalGPSActivos / this.TotalGPS) * 100);
    },
    PorcentajeInactivos() {
      return Math.round((this.TotalGPSInactivos / this.TotalGPS) * 100);
    },
    PorcentajeEstacionados() {
      return Math.round((this.TotalGPSEstacionados / this.TotalGPS) * 100);
    },
    PorcentajeSenalPerd() {
      return Math.round((this.TotalGPSsenalPerd / this.TotalGPS) * 100);
    }
  },
  components: {
    RabbeyTable3,
    RabbeyToolbox,
    ReportGpsDetail,
    //TerminalsReport,
    CardTotal
  },
  created() {
    this.syncAllReport();

    // await    this.syncAllReportButton();
  },

  /*
  monteNombre() {
    this._getGpsQuantity();
  },
  */
  watch: {
    getReportGpsByCurrentUser() {}
  },
  methods: {
    async syncAllReport() {
      this.loading = true;

      //Consulta a los clientes para traer el servicio al cliente
      await this.$http
        .get("/api/customers/CustomersAndCustomerServices")
        .then((resp) => {
          let { data } = resp;

          data.forEach((value) => {
            this.CustomerServicesData.push(value);
          });
        })
        .catch((err) => {
          console.error("Error: ", err);
        });

      //Consulta a los clientes para traer el servicio al cliente
      // await this.$http
      //   .get("/api/navixy/GetTrackerByNavixyService")
      //   .then((resp) => {
      //     // console.log("respuesta desde mi backend"+resp.list.length );

      //             let { data } = resp;
      //       console.log(JSON.stringify(resp.data.list.filter(x=>x.deleted==true).length));

      //     console.error("Error: ", err);
      //   });

      this.reportGps()
        .then((result) => {
          //console.log("result gps: ", result);
          this.Resultado = result;
          this.Resultado.forEach((value) => {
            if (value.original.post_region !== undefined) {
              this.Data.push({
                ClientCode: value.original.post_region,
                CustomerService: this.GetCustomerServiceByClienteCode(
                  value.original.post_region
                ),
                ...value
              });

              // Data.push({
              //   ClientCode:value.original.post_region,
              //   // CustomerService:cliente.CustomerService,
              //   ...value
              //  })

              // })
            }
          });
          // })

          // console.log("CustomerServicesData: ", this.CustomerServicesData)

          // if (value.original.post_region == client.ClientCode) {

          //   console.log( "data  "+ Data.length  );
          // }

          // console.log("customer:"+ this.CustomerServicesData.filter(
          //   (client) => client.ClientCode == value.original.post_region
          // ).CustomerService,)

          //   this.CustomerServicesData.forEach((value)=>{
          //       console.log(value.CustomerService)
          //   }
          // );
          // else {
          //   Data.push({
          // ClientCode: value.original.post_region,
          //     ...value
          //   });

          // }
          // else if (value.original.post_region !== undefined && value.original.post_region !== client.ClientCode) {
          //   Data.push({
          //     ClientCode: value.original.post_region,
          //     ...value
          //   });
          // }

          //  else {
          //   value.original.post_region = "";
          //   Data.push({
          //     ClientCode: value.original.post_region,
          //     ...value
          //   });
          // }
          //NO TOCAR
          // eslint-disable-next-line no-undef
          this.GpsReportViewData = structuredClone(this.Data);
          // JSON.parse(JSON.stringify(this.Data))
          // eslint-disable-next-line no-undef
          this.Resultado = structuredClone(this.Data);

          // console.log("result"+Data .map((item) => item.total_gps)
          //   .reduce((a, b) => a + b))

          this.TotalClientes = this.Data.length;
          this.syncAllReportButton();
          // return this.Resultado;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    ...mapActions("navixy", ["reportGps", "request"]),
    Apply(inicio, fin, _inteval) {
      inicio = new Date(inicio);

      var diff = (inicio.getTime() - fin.getTime()) / 1000;
      diff /= 60 * 60;
      var horas = Math.abs(diff);
      return horas >= _inteval;
    },
    syncAllReportButton() {
      //this.Resultado=[];
      //Data=[];

      //NO TOCAR/
      // eslint-disable-next-line no-undef
      this.Resultado = structuredClone(this.GpsReportViewData);

      if (this.DiasHoras === "") {
        this.$message({
          message:
            "Por favor especificar si es dias o horas el tiempo sin conexion",
          type: "error"
        });
        return;
      } else {
        this.loading = true;
        let _clientesfiltered = [];
        var horas = this.num;

        const Now = new Date();
        if (this.DiasHoras === "Dias") {
          horas *= 24;
        }

        this.Resultado.map((cliente) => {
          // console.log(cliente);
          if (cliente.trackers.length > 0) {
            let _trackers = [];
            cliente.trackers.map((track) => {
              if (this.Apply(track.last_connection, Now, horas)) {
                _trackers.push(track);
              }
            });

            // eslint-disable-next-line no-undef
            cliente.trackers = structuredClone(_trackers);

            cliente.offline = [];
            cliente.offline = _trackers.filter(
              (trk) => trk.source.connection_status === "offline"
            ).length;

            // check.filter(function(element){
            //     return element.status == 'false';
            // }).length

            _clientesfiltered.push(cliente);
          }
          this.loading = false;
          // eslint-disable-next-line no-undef
          this.Resultado = structuredClone(_clientesfiltered);

          // cliente.trackers=aux;
          // return _clientesfiltered;
        });
        // this.loading = false;
        // this.Resultado = _clientesfiltered;
      }
    },

    handleChange() {},

    /*
    getCustomers() {
      this.list = true;
      this.$http
        .get("/api/customers", {
          timeout: 3 * 60 * 1000,
          params: {
            companyId: this.currentCompany
          }
        })
        .then(resp => {
          const { Items } = resp.data;
          for (const i in Items) {
            // Codigo del Cliente
            
            this.ClientCode = Items.ClientCode;
          }
        })
        .catch(error => {
          
        })
        .finally(() => {
          this.loading = false;
        });
    },
    */
    /*
    async _getGpsQuantity() {
      if (this.currentCompany === this.companys.MTR) {
        const userId = await this.$store.dispatch("navixy/searchUserId", {
          client_code: this.ClientCode
        });
        const GPS_Quantity = await this.$store.dispatch("navixy/reportGps12H", {
          sid: userId
        });
        
      }
    },
    
    GetTableData(filtroNombre, Type) {
      this.loading = true;
      this.TableData = [];
      this.$http
        .get("/api/customers/DevicesByClients", {
          timeout: 3 * 60 * 1000,
          params: {
            Cliente: filtroNombre,
            DevicesType: Type
          }
        })
        .then(({ data }) => {
          this.TableData = data;
        })
        .catch(error => {
          this.$message.error(error);
          console.error(error);
          this.TableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    */

    // ClientFilter() {
    //   /*
    //
    //   this.clientNameProp = this.filtroNombre
    //   this.DeviceTypeProp = this.Type
    //   */
    //   this.GetTableData(this.filtroNombre, this.Type);
    // },
    HorasFilter() {},
    onFilterSearch(query) {
      this.$refs.table.filterData(query);
      return;
    },
    openDetail(row, col) {
      this.$refs.detail.show(row, col);
    },
    GetCustomerServiceByClienteCode(code) {
      for (let i = 0; i < this.CustomerServicesData.length; i++) {
        if (this.CustomerServicesData[i].ClientCode == code) {
          return this.CustomerServicesData[i].CustomerService;
        }
      }
    }
  }
};
</script>

<style scoped>
.table {
  margin: auto;
}
.label {
  margin-right: 7px;
  margin-top: 3px;
}
.rowx {
  margin-right: 50px;
}
.toolbox {
  padding-right: 25px;
}
</style>
